module.exports = __webpack_public_path__ + "static/media/v20.335295cd.mp4";